import React from "react";
import LoadRandomProducts from "../Article/LoadRandomProducts";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import "./index.css";

const SidebarBrandsAndProducts = () => {
  // Lazy-load this sidebar component - only fetch when scrolled into view
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  return (
    <div ref={ref}>
      {isVisible ? (
        <div className="sidebarBrandsAndProducts">
          <div className="sidebarBrandsAndProductsInner">
            <div css={{ margin: "0 auto" }}>
              <p
                css={{ fontSize: "14px" }}
                className="recommendedProductsHeading"
              >
                Herb <span>Recommended</span> Products:
              </p>

              <LoadRandomProducts productsToShow={2} marginLeft={"0px"} />
            </div>
          </div>
        </div>
      ) : (
        // Placeholder while loading
        <div
          className="sidebarBrandsAndProducts"
          css={{ minHeight: "200px", background: "#f5f5f5", borderRadius: "4px" }}
        />
      )}
    </div>
  );
};

export default SidebarBrandsAndProducts;
